import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import SiteFooter from '@/components/SiteFooter';
import FaqObjections from '@/components/landing/FaqObjections';

/**
 * Questions fréquentes — sortie de la landing, qui atteignait 13 écrans sur mobile.
 *
 * La FAQ pesait 1,9 écran à elle seule. Sur sa propre page, elle garde son intérêt
 * SEO (les trois réponses restent ouvertes, donc indexables) sans peser sur le
 * chemin vers le dépôt.
 */
const FaqPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f8fafc' }}>
      <Header />
      {/* Pas de formulaire sur cette page : le CTA renvoie à la landing. */}
      <FaqObjections onCTAClick={() => navigate('/')} />
      <SiteFooter />
    </div>
  );
};

export default FaqPage;
